import React from 'react'
import { Field, ErrorMessage } from 'formik'
import {
  Container,
  Label,
  RadioContainer,
  RolesContainer,
  RadioLabel,
} from './AccountDetailsRolesRadioInput.styles'

const AccountDetailsRolesRadioInput = props => {
  const { label, name, jobRoles, value, ErrorContainer } = props
  return (
    <Container>
      <Label>
        {label}
        <ErrorContainer>
          <ErrorMessage name="title" />
        </ErrorContainer>
      </Label>
      <RolesContainer role="group">
        {jobRoles.map(jobRole => {
          return (
            <RadioContainer key={jobRole.id}>
              <Field
                checked={value === jobRole.id}
                name={name}
                type="radio"
                value={jobRole.id}
              />
              <RadioLabel>{jobRole.name}</RadioLabel>
            </RadioContainer>
          )
        })}
      </RolesContainer>
    </Container>
  )
}

export default AccountDetailsRolesRadioInput



// WEBPACK FOOTER //
// ./src/components/AccountDetailsRolesRadioInput/AccountDetailsRolesRadioInput.js